<template>
    <BaseCard v-if="tonalThemeEnabled" v-bind="$attrs" padding="sm">
        <div class="border-b border-border body-small pb-4 mb-4 text-ink-muted">
            <i class="bi bi-people-fill mr-2" aria-hidden="true"></i>{{ t("components.calendar.attendees.count", { count: attendees.length }, attendees.length) }}
        </div>
        <div class="max-h-50 overflow-auto flex flex-col gap-2">
            <div v-for="attendee in attendees" :key="attendee.email || attendee.name" class="text-ink-muted flex gap-2 items-center">
                <CalendarAttendeeAvatar :name="attendee.name" :email="attendee.email" />
                <span class="body-small">{{ attendee.name || attendee.email }}</span>
            </div>
        </div>
    </BaseCard>
    <div v-else v-bind="$attrs" class="px-4 py-5 rounded-lg bg-surface-raised border border-border-strong">
        <div class="border-b border-border body-small pb-4 mb-4 text-ink-muted">
            <i class="bi bi-people-fill mr-2" aria-hidden="true"></i>{{ t("components.calendar.attendees.count", { count: attendees.length }, attendees.length) }}
        </div>
        <div class="max-h-50 overflow-auto flex flex-col gap-2">
            <div v-for="attendee in attendees" :key="attendee.email || attendee.name" class="text-ink-muted flex gap-2 items-center">
                <CalendarAttendeeAvatar size="xs" :name="attendee.name" :email="attendee.email" />
                <span class="body-small font-normal">{{ attendee.name || attendee.email }}</span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseCard from "~vue/components/BaseCard.vue";
import CalendarAttendeeAvatar from "~vue/components/CalendarAttendeeAvatar.vue";
import { tonalThemeEnabled } from "~vue/utils/theme";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

defineOptions({ inheritAttrs: false });

const { attendees } = defineProps<{ attendees: Array<{ name: string; email: string }> }>();
// TODO: Remove the legacy calendar branch once the tonal theme becomes the default.
</script>
